import GuidedOfferCampaignCard from '../../client/svelte/components/GuidedOfferCampaignCard.svelte';



window.GuidedOfferCampaignCard = GuidedOfferCampaignCard;